import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const notThis = ['This is not a collection of random exercises pulled from the internet.', 'This is not a theory book you have to rewrite before it works in a real training session.', 'This is not content designed for a different type of coach that you have to completely adapt.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-cream relative overflow-hidden" data-id="element-224" data-mp="z2foehqopiuu">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-brand/40" data-id="element-225" data-mp="u2tccbmle8nm" />
      <div className="max-w-4xl mx-auto text-center" data-id="element-226" data-mp="182kkvwucawu8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-227" data-mp="183dx3dc2iejr">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-brand-soft border border-brand/25 mb-5" data-id="element-228" data-mp="2jj2gjuq44vft">
            <span className="text-2xl" aria-hidden="true" data-id="element-229" data-mp="2bwia6wqny077">
              🏆
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-extrabold mb-4 text-ink" data-id="element-230" data-mp="2gtqx1amrases">
            The most complete Ninja coaching system for obstacle-course coaches worldwide
          </h2>
          <h3 className="text-xl font-bold text-brand mb-3" data-id="element-231" data-mp="2pufaa34bsoqm">Ninja Coach Ready™</h3>
          <p className="text-base md:text-lg text-graphite mb-10" data-id="element-232" data-mp="1t5r5i8hmexz5">
            150 classes ready to teach · 6 complete volumes · 5 strategic bonuses · Everything ready
            to use from today
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-233" data-mp="22548qjf5iqbf">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-white p-6 rounded-2xl border border-silver-light" data-id="element-234" data-mp="26x5qulz03b9d">
            {notThis.map(item => <div key={item} className="flex items-start gap-3" data-id="element-235" data-mp="2hp4hfwf2778l">
                <X className="text-silver shrink-0 mt-1" size={18} aria-hidden="true" data-id="element-236" data-mp="2crcpx3ibtn4x" />
                <p className="text-graphite-light text-sm" data-id="element-237" data-mp="2qjsons472z01">{item}</p>
              </div>)}
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-brand-soft p-6 rounded-2xl border border-brand/30" data-id="element-238" data-mp="2mih2xxofyxx4">
            <div className="flex items-start gap-3" data-id="element-239" data-mp="27uclex14ksfx">
              <Check className="text-brand shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-240" data-mp="22touebcwcblp" />
              <p className="text-ink font-medium text-base leading-relaxed" data-id="element-241" data-mp="3j7orlekcxn59">
                This is a complete professional coaching system — so you walk into every class
                completely prepared, confident, and ready to deliver a session your athletes will
                feel.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}